import { c as _c } from "react/compiler-runtime";
import { useAnalyticsInitialization } from "@faro-lotv/foreign-observers";
import { useManualPageViewTracking } from "@hooks/use-manual-page-view-tracking";
import { useAppParams } from "@router/router-helper";
import { runtimeConfig } from "@src/runtime-config";
import { selectedProjectSelector } from "@store/projects/projects-selector";
import { selectedSdbCompanyCategorySelector, selectedSdbCompanyIdSelector, selectedSdbCompanyNameSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";
import { getAmplitudeKeys } from "@utils/amplitude-utils";
import { useMemo } from "react";

/**
 * Initializes Analytics module for tracking.
 */
export function useInitAppAnalytics() {
  const $ = _c(16);
  const loggedInUser = useAppSelector(loggedInUserSelector);
  const selectedSdbCompanyId = useAppSelector(selectedSdbCompanyIdSelector);
  const selectedProject = useAppSelector(selectedProjectSelector);
  const selectedSdbCompanyName = useAppSelector(selectedSdbCompanyNameSelector);
  const workspaceCategory = useAppSelector(selectedSdbCompanyCategorySelector);
  const params = useAppParams();
  selectedProject?.name;
  loggedInUser?.firstName;
  loggedInUser?.lastName;
  loggedInUser?.email;
  const t0 = selectedProject?.name;
  const t1 = selectedSdbCompanyName ?? undefined;
  const t2 = loggedInUser?.firstName;
  const t3 = loggedInUser?.lastName;
  const t4 = loggedInUser?.email;
  let t5;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = {
      projectName: t0,
      companyName: t1,
      userFirstName: t2,
      userLastName: t3,
      userEmail: t4
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const privateData = t5;
  let t6;
  if ($[6] !== loggedInUser) {
    t6 = getAmplitudeKeys({
      loggedInUser,
      appEnv: runtimeConfig.appEnv
    });
    $[6] = loggedInUser;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const amplitudeKeys = t6;
  const t7 = loggedInUser?.email;
  const t8 = selectedSdbCompanyId ?? params.companyId;
  const t9 = selectedProject?.id ?? params.projectId;
  const t10 = loggedInUser?.id;
  let t11;
  if ($[8] !== amplitudeKeys || $[9] !== privateData || $[10] !== t10 || $[11] !== t7 || $[12] !== t8 || $[13] !== t9 || $[14] !== workspaceCategory) {
    t11 = {
      app: "XG Dashboard",
      appVersion: runtimeConfig.appVersion,
      keys: amplitudeKeys,
      currentUserEmail: t7,
      companyId: t8,
      companyCategory: workspaceCategory,
      projectId: t9,
      userId: t10,
      region: runtimeConfig.appRegion,
      environment: runtimeConfig.environment,
      privateData,
      ignoreInternalUsers: false,
      ignoreAnonymousUsers: true,
      defaultTracking: false
    };
    $[8] = amplitudeKeys;
    $[9] = privateData;
    $[10] = t10;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = workspaceCategory;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  useAnalyticsInitialization(t11);
  useManualPageViewTracking();
}